module.exports = __webpack_public_path__ + "static/media/1_A1_19.36d5de6b.png";